<template>
  <div class="forensics"   v-loading="loading">
    <div class="details-title">公证书领取</div>
    <div class="forensics_con">
      <div class="forensics_con_item_info">
        <p>
          <span>公证书要求：</span>
          <span
            v-show="notarizationInfo.notaryCertificateType==3 && notarizationInfo.recipientType==1"
          >电子公证书和纸质公证书本人领取</span>
          <span
            v-show="notarizationInfo.notaryCertificateType==3 && notarizationInfo.recipientType==2"
          >电子公证书和纸质公证书他人领取</span>
          <span v-show="notarizationInfo.notaryCertificateType==1">电子公证书</span>
        </p>
        <p v-if="notarizationInfo.notaryCertificateType==3">
          <span>领取时间：</span>
          <span>{{format(notarizationInfo.receiveDate,1)}}</span>
        </p>
        <p v-if="notarizationInfo.notaryCertificateType==3">
          <span>公证处：</span>
          <span>{{notarizationInfo.notarial}}</span>
        </p>
        <p v-if="notarizationInfo.notaryCertificateType==3">
          <span>线下取证地址：</span>
          <span>{{notarizationInfo.receiveAddress?notarizationInfo.receiveAddress:notarizationInfo.location}}</span>
        </p>
        <p>
          <span>电子公证书：</span>
          <span class="forensics_operation" @click="showCer">预览</span>
          <span class="forensics_operation" @click="downLoadFn">下载</span>
        </p>
        <p
          class="message"
          v-if="notarizationInfo.notaryCertificateType==3"
        >提示：请委托人务必携带身份证件及证明前往公证处领取公证书和公证文件</p>
      </div>
      <div class="forensics_con_item_notarization">
        <!-- <VueQr id :text="notarizationUrl"></VueQr> -->
         <canvas id="codeCanvas"></canvas>
        <span>扫码查看电子公证书</span>
      </div>
    </div>
  </div>
</template>
<script>
import VueQr from "qrcode";
import Dialog from "@common/Dialog.vue";
import BaseApi from "@lib/baseApi.js";
export default {
  props: ["notarizationInfo"],
  data() {
    return {
      //扫码查看公证处书url
      notarizationUrl: "",
      //下载文件url
      downloadUrl: "",
      user:"",
      notaryBusinessId: "",
      queryCount:0,
      loading:false
    };
  },
  components: { VueQr },
  methods: {
    //预览
    showCer(index) {
      let id, type;
      type = 1;
      id = this.notarizationInfo.certificateDataRightId || '30';
      this.$router.push({
        path: "/personal/serviceHome/writeProcedure/lookFqCeryificate",
        query: {
          id,
          type,
          notaryBusinessId: this.notaryBusinessId
        }
      });
    },
    getBase64(imgUrl) {
            return new Promise(resolve => {
                window.URL = window.URL || window.webkitURL;
                var xhr = new XMLHttpRequest();
                xhr.open("get", imgUrl, true);
                // xhr.setRequestHeader("Referer", "https://gzfq_gzc_test.ip360.or");
                // 至关重要
                xhr.responseType = "blob";
                xhr.onload = function () {
                    if (this.status == 200) {
                        //得到一个blob对象
                        var blob = this.response;
                        // 至关重要
                        let oFileReader = new FileReader();
                        oFileReader.onloadend = function (e) {
                            let base64 = e.target.result;
                            // 返回解码后的base64
                            resolve(base64)
                        };
                        oFileReader.readAsDataURL(blob);
                    }
                }
                xhr.send();

            })
        },
    //下载
    downLoadFn(){
      // if(item.type==2){//存证下载
        BaseApi.createRpcToken("/notaryApply/downloadDataRight", { rightId: this.notarizationInfo.certificateDataRightId })
          .then(data => {
            console.log(data);
             if ( data.code==200){
              this.loading=false
                // this.getBase64(data.datas.packageUrl.path).then(res=>{
                //   console.log(res)
                // })
                var elemIF = document.createElement("iframe");
                elemIF.setAttribute('id', 'startDown');
                elemIF.src = data.datas.path;
                elemIF.style.display = "none";
                if(document.getElementById('startDown')) {
                  document.body.removeChild(document.getElementById('startDown'));
                }
                document.body.appendChild(elemIF);
                // var a = document.createElement('a');
                // a.setAttribute('href', data.datas.packageUrl.path);
                // a.setAttribute('target', '_blank');
                // a.setAttribute('id', 'startDown');
                // // 防止反复添加
                // if(document.getElementById('startDown')) {
                //   document.body.removeChild(document.getElementById('startDown'));
                // }
                // document.body.appendChild(a);
                // a.click();
              }else if (data.code==20001){
                // this.$message.error(data.datas.packageUrl.message);
                
                this.loading=true
                if(this.queryCount<4){
                  setTimeout(()=>{
                    this.queryCount++
                    console.log(this.queryCount);
                    this.downLoadFn()
                  },2000)
                }else{
                  this.queryCount=0
                this.$message.error(data.message);
                }
              }
          })
          .catch(function(e) {
            errorLog(e);
          });
      // }else{
      //   //签约下载
      //     BaseApi.createRpcToken("/file/download", { id: item.fileId })
      //     .then(data => {
      //       if (data.datas.zipUrl) {
      //         try {
      //           var elemIF = document.createElement("iframe");
      //           elemIF.setAttribute('id', 'startDown');
      //           elemIF.src = data.datas.zipUrl;
      //           elemIF.style.display = "none";
      //           if(document.getElementById('startDown')) {
      //             document.body.removeChild(document.getElementById('startDown'));
      //           }
      //           document.body.appendChild(elemIF);
      //         } catch (e) {}
      //         // window.open(data.datas.zipUrl);
      //       } else {
      //         this.$message.error("下载失败");
      //       }
      //     })
      //     .catch(function(e) {
      //       errorLog(e);
      //     });
      // }
    },
     format(value,type){
        // 1-年月日，2-年月日+时分秒
        var newValue=value,t1,t2,d2="";
        // if(value+''.indexOf('~')!=-1){
        //   newValue=value+''.split("~");
        //   t1=new Date(newValue[0]);
        //   t2=new Date(newValue[1]);
        //   if(type==1){
        //     d2 = this.getYMH(t2,type);
        //   }else{
        //     d2 = this.getYMH(t1,type)+" ~ "+this.getYMH(t2,type)
        //   }
        //   return d2;
        // }else{
          var d=new Date(newValue);
          if(type==1){
            d2 = this.getYMH(d,type);
          }else{
            d2 = this.getYMH(d,type);
          }
          return d2;
        // }
      },
      getAdd(time){
        if(time>9){
          return time
        }else{
          return "0"+time
        }
      },
      getYMH(dateTime,type){
        if(type==1){
          return dateTime.getFullYear() + "年"+ this.getAdd(dateTime.getMonth() + 1) +"月"+ this.getAdd(dateTime.getDate()) +"日";
        }else{
          return dateTime.getFullYear() + "年"+ this.getAdd(dateTime.getMonth() + 1) +"月"+ this.getAdd(dateTime.getDate()) +"日"+this.getAdd(dateTime.getHours())+"时"+this.getAdd(dateTime.getMinutes())+"分"+this.getAdd(dateTime.getSeconds())+"秒";
        }
      },
  },
  created() {
    this.notaryBusinessId = this.$route.query.notaryBusinessId;
    this.notarizationUrl =
     this.$GlobalConfig.lookCeryificateUrl +
      "/ip360_mobile/activities/qrCodeShare.html?id=" +
      this.notarizationInfo.certificateDataRightId +
      "&type=1";
       setTimeout(()=>{
          var canvas = document.getElementById('codeCanvas')
        VueQr.toCanvas(canvas, this.notarizationUrl, {width:140,height:140,margin:1},function (error) {
        })
      },10)
  },
  
  mounted() {
    // this.user = JSON.parse(sessionStorage.getItem("userInfo"));
    // this.downloadUrl = this.$GlobalConfig.lookCeryificateUrl + "/webapi/extractEvidence/v2/downloadExist?";
    // this.downloadUrl =
    //   this.downloadUrl +
    //   "rightId=" +
    //   this.notarizationInfo.id+"&sign="+this.$md5('rightId='+this.notarizationInfo.id+'snapShotIdmobileId');
  }
};
</script>
<style lang="scss" scoped>
.forensics {
  width: 100%;
  .details-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    height: 46px;
    padding: 0 15px;
    border: 1px solid #e4e4e4;
    //   border-bottom: 1px solid #e4e4e4;
    background: url(../../../../../../assets/images/judicial/arrow.png) no-repeat #f9f9f9;
    background-position: 15px 17px;
    padding-left: 32px;
    span:nth-child(2) {
      font-size: 14px;
      font-weight: 500;
      color: #a0a0a0;
    }
  }
  .forensics_con {
    width: 100%;
    background: #f9f9f9;
    border: 1px solid #e4e4e4;
    display: flex;
    height: 252px;
    justify-content: space-around;
    align-items: center;
    margin-bottom: 30px;
    border-top: 0px;
    .forensics_con_item_info {
      flex-shrink: 0;
      width: 549px;
      p {
        height: 37px;
        line-height: 37px;
      }
      .message {
        color: #d81212;
      }
      .forensics_operation {
        color: #0885e1;
        cursor: pointer;
        padding: 0px 20px;
      }
    }
    .forensics_con_item_notarization {
      text-align: center;
      span {
        display: block;
        margin-top: 30px;
      }
    }
  }
}
</style>